import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

export const set = property => (state, payload) => (state[property] = payload)
export const toggle = property => state => (state[property] = !state[property])

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
    key: 'my-app',
    storage: window.localStorage
})

export default new Vuex.Store({
    plugins: [vuexPersist.plugin],
    state: {
        authenticated: null,
        permissions: [],
        drawer: null,
        responsive: true,
        color: 'success',
        nomeUsuario: "",
        passaporte: "",
        token: null,
        pessoaId: null,
        reLogin: false,
    },
    mutations: {
        setDrawer: set('drawer'),
        setImage: set('image'),
        setColor: set('color'),
        toggleDrawer: toggle('drawer'),
        setResponsive: set('responsive'),
        setPermissions: set('permissions'),
        setAuthenticated: set('authenticated'),
        setNomeUsuario: set('nomeUsuario'),
        setPassaporte: set('passaporte'),
        setToken: set('token'),
        setPessoaId: set('pessoaId'),
        setReLogin: set('reLogin')
    },
    actions: {
        login(context, {nome, passaporte, token, permissoes, pessoaId}) {
            try {
                context.commit('setNomeUsuario', nome)
                context.commit('setPassaporte', passaporte)
                context.commit('setAuthenticated', true)
                context.commit('setPermissions', permissoes)
                context.commit('setToken', token)
                context.commit('setPessoaId', pessoaId)
                context.commit('setReLogin', false)
            } catch (err) {
                console.error(err)
            }
        },
        logout(context) {
            try {
                context.commit('setAuthenticated', false)
                context.commit('setPermissions', [])
                context.commit('setNomeUsuario', "")
                context.commit('setPassaporte', "")
                context.commit('setToken', "")
                context.commit('setPessoaId', "")
                context.commit('setReLogin', false)
            } catch (err) {
                console.error(err)
            }
        },
        markReLogin(context) {
            try {
                context.commit('setReLogin', true)
            } catch (err) {
                console.error(err)
            }
        }
    }
})
